class AdpDropdownController {
  constructor() {
      this.name = 'adpDropdown';
      this.opened = false;
  }
  toggle() {
    this.opened = !this.opened;
  }
}

export default AdpDropdownController;



// WEBPACK FOOTER //
// ./src/app/components/adpDropdown/adpDropdown.controller.js